import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiAlertTriangle, FiLock, FiArrowRight } = FiIcons;

const NoticeSection = () => {
  return (
    <section className="bg-gradient-to-r from-orange-600 to-red-600 py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center text-white">
          <div className="flex justify-center mb-4">
            <SafeIcon icon={FiAlertTriangle} className="h-8 w-8 text-yellow-300" />
          </div>
          <h3 className="text-2xl font-bold mb-4">Notice</h3>
          <p className="text-lg mb-6 max-w-4xl mx-auto leading-relaxed">
            ⚠️ <strong>Notice:</strong> This website is created only for student practice. Account4Web experts have not fixed technical issues here – so you can clearly see the real work level of students. Almost 80% of the website is perfect, and the remaining 20% is polished by experts in final projects.
          </p>
          <div className="flex justify-center items-center space-x-4 mb-6">
            <SafeIcon icon={FiLock} className="h-6 w-6 text-green-300" />
            <p className="text-lg">
              🔒 We never share any client website made under this offer with others – your project privacy is 100% safe.
            </p>
          </div>
          <a 
            href="https://projects.azaansuperpc.com/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-flex items-center space-x-2 bg-white text-red-600 font-bold py-3 px-6 rounded-lg hover:bg-gray-100 transition-colors duration-300"
          >
            <span>👉 Check Offer</span>
            <SafeIcon icon={FiArrowRight} className="h-4 w-4" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default NoticeSection;